import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSapComponent } from './simple-icons-sap.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSapComponent ],
    exports:      [ SimpleIconsSapComponent ],
    bootstrap:    []
})
export class SimpleIconsSapModule {}
